import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import Branch from "./Components/Pages/Branch";
import Sidebar from "./Components/Sidebar/Sidebar";
import Users from "./Components/Pages/Users";
import Products from "./Components/Pages/Products";
// import Dealer from "./Components/Pages/Dealer";
import Stocks from "./Components/Pages/Stocks";
import Customer from "./Components/Pages/Customers";
import Sales from "./Components/Pages/Sales";
import Purchase from "./Components/Pages/Purchases";
import Navigatesales from "./Components/Pages/Navigatesales";
import Navigatepurchase from "./Components/Pages/Navigatepurchase";
import Dashboard from "./Components/Pages/Dashboard";
import Report from "./Components/Pages/Report";
import Login from "./Components/Login/Login";
import ProtectedRoute from "./Components/Pages/Helper";
import UpdateSales from "./Components/Pages/UpdateSales";
import Productcategory from "./Components/Pages/Productcategory";
import Invoice_bill from "./Components/Pages/Invoice_bill";
import Purchase_update from "./Components/Pages/Purchase_update";
import Dummy from "./Components/Pages/Dummy";
import Dummy1 from "./Components/Pages/Dummy1";
import Purchase_Bill from "./Components/Pages/Purchase_Bill";
import Invoice from "./Components/Pages/Invoice";
import Personal_Stock from "./Components/Pages/Personal_Stock";

function MainApp() {
  const [collapsed, setCollapsed] = useState(false);
  const [sidebarVisible, setSidebarVisible] = useState(false);
  const [isMobileOrTablet, setIsMobileOrTablet] = useState(
    window.innerWidth < 992
  );

  const location = useLocation();
  const isLoginOrInvoicePage =
    location.pathname === "/" ||
    location.pathname.startsWith("/invoice") ||
    location.pathname.startsWith("/purchase_bill");

  useEffect(() => {
    function handleResize() {
      const mobileOrTablet = window.innerWidth < 992;
      setIsMobileOrTablet(mobileOrTablet);
      if (!mobileOrTablet) {
        setSidebarVisible(false);
      }
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleSidebar = () => {
    if (isMobileOrTablet) {
      setSidebarVisible((prev) => !prev);
    } else {
      setCollapsed((prev) => !prev);
    }
  };

  const closeSidebarMobile = () => {
    setSidebarVisible(false);
  };

  return (
    <div className="d-flex vh-100">
      {!isLoginOrInvoicePage && (
        <Sidebar
          collapsed={collapsed}
          toggleSidebar={toggleSidebar}
          isMobile={isMobileOrTablet}
          sidebarVisible={sidebarVisible}
          closeSidebarMobile={closeSidebarMobile}
        />
      )}

      <div
        className="flex-grow-1"
        style={{
          overflowX: "auto",
          transition: "margin-left 0.3s ease",
          marginTop: isMobileOrTablet ? 0 : 10,
          marginLeft:
            isLoginOrInvoicePage || isMobileOrTablet ? 0 : collapsed ? 10 : 25,
          marginRight:
            isLoginOrInvoicePage || isMobileOrTablet ? 0 : collapsed ? 5 : 25,
        }}
      >
        {!isLoginOrInvoicePage && isMobileOrTablet && (
          <div
            className="mb-3"
            style={{
              paddingLeft: "20px",
              paddingTop: "10px",
              maxWidth: "fit-content",
            }}
          >
            <button
              className="btn btn-danger"
              onClick={toggleSidebar}
              aria-label="Toggle sidebar"
              style={{
                minWidth: "50px",
                minHeight: "38px",
                fontSize: "1.5rem",
              }}
            >
              ☰
            </button>
          </div>
        )}

        <Routes>
          <Route
            path="/branch"
            element={
              <ProtectedRoute>
                <Branch />
              </ProtectedRoute>
            }
          />

          <Route
            path="/invoice/:id"
            element={
              <ProtectedRoute>
                <Invoice_bill />
              </ProtectedRoute>
            }
          />

          <Route
            path="/invoice_sales/:Sales_ID"
            element={
              <ProtectedRoute>
                <Invoice />
              </ProtectedRoute>
            }
          />

          <Route
            path="/purchase_bill/:id"
            element={
              <ProtectedRoute>
                <Purchase_Bill />
              </ProtectedRoute>
            }
          />

          <Route
            path="/user"
            element={
              <ProtectedRoute>
                <Users />
              </ProtectedRoute>
            }
          />

          <Route
            path="/purchase_update/:id"
            element={
              <ProtectedRoute>
                <Purchase_update />
              </ProtectedRoute>
            }
          />

          <Route
            path="/products"
            element={
              <ProtectedRoute>
                <Products />
              </ProtectedRoute>
            }
          />
          {/* 
          <Route
            path="/dealer"
            element={
              <ProtectedRoute>
                <Dealer />
              </ProtectedRoute>
            }
          /> */}

          <Route
            path="/stocks"
            element={
              <ProtectedRoute>
                <Stocks />
              </ProtectedRoute>
            }
          />

          <Route
            path="/personal_stock"
            element={
              <ProtectedRoute>
                <Personal_Stock />
              </ProtectedRoute>
            }
          />

          <Route
            path="/customers"
            element={
              <ProtectedRoute>
                <Customer />
              </ProtectedRoute>
            }
          />

          <Route
            path="/updateSales/:Sales_ID"
            element={
              <ProtectedRoute>
                <UpdateSales />
              </ProtectedRoute>
            }
          />

          <Route
            path="/sales"
            element={
              <ProtectedRoute>
                <Sales toggleSidebar={toggleSidebar} />
              </ProtectedRoute>
            }
          />

          <Route
            path="/Purchases"
            element={
              <ProtectedRoute>
                <Purchase toggleSidebar={toggleSidebar} />
              </ProtectedRoute>
            }
          />

          <Route
            path="/Navigatesales"
            element={
              <ProtectedRoute>
                <Navigatesales />
              </ProtectedRoute>
            }
          />

          <Route
            path="/Navigatepurchases"
            element={
              <ProtectedRoute>
                <Navigatepurchase />
              </ProtectedRoute>
            }
          />

          <Route
            path="/Productcategory"
            element={
              <ProtectedRoute>
                <Productcategory />
              </ProtectedRoute>
            }
          />

          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />

          <Route
            path="/report"
            element={
              <ProtectedRoute>
                <Report />
              </ProtectedRoute>
            }
          />

          <Route
            path="/dummy"
            element={
              <ProtectedRoute>
                <Dummy />
              </ProtectedRoute>
            }
          />

          <Route
            path="/dumone"
            element={
              <ProtectedRoute>
                <Dummy1 />
              </ProtectedRoute>
            }
          />

          <Route path="/" element={<Login />} />
        </Routes>
      </div>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <MainApp />
    </BrowserRouter>
  );
}

export default App;
